import Typography from "@mui/material/Typography";
import TextFieldStyled from "@/components/TextFieldStyled";
import {GenreSelectorMultiple} from "@/components/bandcreate/GenreSelectorMultiple";

const NetworkLocationFormLabels = ({onChange}) => {
    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Labels)
            </Typography>
            <GenreSelectorMultiple
                label="Genre *"
                hint="Wähle bis zu drei"
                onChange={handleInputChanged}
            />
            <TextFieldStyled
                type="number"
                name="num_creators"
                label="Anzahl vertretenen Künstler:innen"
                placeholder="500"
                onChange={handleInputChanged}
            />
            <TextFieldStyled
                type="number"
                name="num_publications"
                label="Anzahl Veröffentlichungen"
                placeholder="500"
                onChange={handleInputChanged}
            />
        </>
    )
}

export default NetworkLocationFormLabels;
